import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const LoginPage = withSuspense(lazy(() => import('./login-page')));
export default LoginPage;
